module.exports = __webpack_public_path__ + "img/dashboard-main-mobile-ru.e159f8b8.jpg";